import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=1596f120&scoped=true"
import script from "./Bill.ts?vue&type=script&lang=ts&external"
export * from "./Bill.ts?vue&type=script&lang=ts&external"
import style0 from "./Bill.vue?vue&type=style&index=0&id=1596f120&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596f120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1596f120')) {
      api.createRecord('1596f120', component.options)
    } else {
      api.reload('1596f120', component.options)
    }
    module.hot.accept("./Bill.vue?vue&type=template&id=1596f120&scoped=true", function () {
      api.rerender('1596f120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/pages/Bill/Bill.vue"
export default component.exports